import React from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';
import CloseIcon from '@atlaskit/icon/core/close';
import { IconButton } from '@atlaskit/button/new';

const dismissIconStyles = xcss({
	position: 'absolute',
	top: 'space.0',
	right: 'space.0',
	cursor: 'pointer',
});

export const HTV2DismissButton = ({
	onDismiss,
	label,
}: {
	onDismiss?: () => void;
	label: MessageDescriptor;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={dismissIconStyles}>
			<IconButton
				isTooltipDisabled={false}
				onClick={onDismiss}
				label={formatMessage(label)}
				appearance="subtle"
				icon={(iconProps) => <CloseIcon {...iconProps} />}
			/>
		</Box>
	);
};
